class BundleBox {
    constructor(apiUrl, productPlatformId) {
        this._apiUrl = apiUrl;
        this._productPlatformId = productPlatformId;
        this._totalQuantity = 0;
        this._totalSum = 0;
        this._removeAlert = null;
        this._compareAtPrice = 59.85;

        this._elements = {
        totalContainer: document.querySelector('.js-bundle-box-total'),
        subtotalContainer: document.querySelector('.js-bundle-box-subtotal'),
        totalSumContainer: document.querySelector('.js-bundle-box-total-sum'),
        subtotalSum: document.querySelector('.js-bundle-box-subtotal-sum'),
        subtotalDiscount: document.querySelector('.js-bundle-box-discount'),
        subtotalDiscountSum: document.querySelector('.js-bundle-box-discount-sum'),
        subtotalQuantity: document.querySelector('.js-bundle-box-quantity'),
        subtotalQuantityText: document.querySelector('.js-bundle-box-quantity-text'),
        alertContainer: document.querySelector('.js-bundle-box-alert'),
        boxContainer: document.querySelector('.js-bundle-box-products'),
        closeButton: document.querySelector('.js-bundle-box-cart-close'),
        cartBlock: document.querySelector('.js-bundle-box-cart'),
        cartSum: document.querySelector('.js-bundle-box-cart-sum'),
        recurringPrices: document.querySelector('.js-bundle-box-recurring-prices'),
        addAllToCartButton: document.querySelector('.js-bundle-box-checkout'),
        bundleScale: document.querySelector('.js-bundle-box-scale'),
        };

        // Data from API response
        this._selectableProductVariants = [];
        this._fixedDiscounts = null;
        this._sizeRangeMin = null;
        this._sizeRangeMax = null;
        this._sellingPlanGroup = null;
        this._boxId = null;
        this._sellingPlanId = null;

        this._init();
    }

    async _init() {
        const data = await this._fetchData();

        if (data && data.DynamicBox) {
            console.log(data);
            const dynamicBox = data.DynamicBox;
            this._selectableProductVariants = dynamicBox.selectableProductVariants || [];
            this._fixedDiscounts = dynamicBox.fixedDiscountTier;
            [this._sizeRangeMin, this._sizeRangeMax] = dynamicBox.sizeRange || [];
            this._sellingPlanGroup = dynamicBox.sellingPlanGroup;
            this._boxId = dynamicBox.boxId;

            if (this._sellingPlanGroup) {
                const targetPlan = Object.entries(this._sellingPlanGroup).find(([key, plan]) => plan.intervalCount === 30);

                if (targetPlan) {
                    const [key] = targetPlan;
                    this._sellingPlanId = key.split('/').pop();
                } 
            }

            const sellingPlans = dynamicBox.sellingPlanGroup;
            const firstPlanKey = Object.keys(sellingPlans)[0]; 
            const firstPlan = sellingPlans[firstPlanKey];

            const firstVariantKey = Object.keys(firstPlan.variantMapping)[0];
            this._defaultPrice = Math.round(firstPlan.variantMapping[firstVariantKey].adjustedPrice * 100) / 100;

            this._renderProductCards();
            this._setupCartCloseHandler();
            this._updateCloseButtonState();
            this._addScaleElements();
            this._updateRecurringPrice();
        }
    }

    async _fetchData() {
        try {
        const response = await fetch(this._apiUrl, {
            method: 'POST',
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ "productPlatformId": this._productPlatformId })
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        return await response.json();

        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    }

    _addScaleElements() {
        this._scaleElements = [];

        Object.entries(this._fixedDiscounts).forEach(([key, value]) => {
            const quantity = parseInt(key, 10);
            const discount = parseFloat(value);
            const discountSum = (this._compareAtPrice * quantity) - (this._defaultPrice * quantity) + discount;

            const scaleElement = document.createElement('div');
            scaleElement.classList.add('bundle-box__scale-element');

            const scaleElementNumber = document.createElement('span');
            scaleElementNumber.classList.add('bundle-box__scale-number');
            scaleElementNumber.textContent = quantity;

            const scaleSrOnly = document.createElement('span');
            scaleSrOnly.classList.add('sr-only');
            scaleSrOnly.textContent = 'Items in box';
            scaleElementNumber.appendChild(scaleSrOnly);

            const scaleElementSum = document.createElement('span');
            scaleElementSum.classList.add('bundle-box__scale-sum');
            scaleElementSum.textContent =`$${discountSum.toFixed(2)} Off`;

            scaleElement.appendChild(scaleElementNumber);
            scaleElement.appendChild(scaleElementSum);

            this._elements.bundleScale.appendChild(scaleElement);

            this._scaleElements.push({ quantity, element: scaleElement });
        });      
    }

    _showTemporaryAlert({ duration = 3000, sum = null } = {}) {
        if (this._totalQuantity >= this._sizeRangeMax) {
        this._elements.alertContainer.innerHTML = `Bundle complete! You’re saving <span>${sum}</span>. Let’s check out`;
        this._elements.alertContainer.classList.remove('custom-hidden');
        } else {
        if (this._totalQuantity < this._sizeRangeMin) {
            this._elements.alertContainer.innerHTML = `Please select at least <span>${this._sizeRangeMin}</span> items before checkout`;
            this._elements.alertContainer.classList.remove('custom-hidden');
        } else {
            this._elements.alertContainer.innerHTML = '';
            this._elements.alertContainer.classList.add('custom-hidden');
        }
        }
        clearTimeout(this._removeAlert);
        this._removeAlert = setTimeout(() => {
        this._elements.alertContainer.innerHTML = '';
        this._elements.alertContainer.classList.add('custom-hidden');
        }, duration);
    }

    _roundTo2(num) {
        return Math.round(num * 100) / 100;
    }

    _parseProductTitle(str) {
        if (typeof str !== 'string') return { titleText: '', sizeText: '' };
        const parts = str.split(" / ");
        return {
        titleText: parts[0] || '',
        sizeText: parts[1] || ''
        };
    }

    _updateQuantityText(quantity) {
        this._elements.subtotalQuantityText.textContent = (quantity === 1) ? 'item' : 'items';
    }

    _updateRecurringPrice() {
        const disclamerPrice = document.querySelector('[data-bundle-disclamer-price]');
        disclamerPrice.textContent = `$${this._selectableProductVariants[0].productVariants[0].price}`;
    }

    _handleCartItemByVariant(variant, assignToElement = null, returnCartQuantity = false, assignToCard = null) {
        const str = variant.platformId;

        const variantId = str.slice(str.lastIndexOf("/") + 1);

        if (assignToElement) {
        assignToElement.dataset.variantId = variantId;
        return assignToElement;
        } else if (returnCartQuantity) {
        return document.querySelector(`.product-card[data-variant-id="${variantId}"] .quantity-selector span`);
        } else if (assignToCard) {
        assignToCard.dataset.variantId = variantId;
        } else {
        return document.querySelector(`.bundle-cart-item[data-variant-id="${variantId}"]`);
        } 
    }

    _updateQuantityInCart(variant, newQuantity) {
        const cartItem = this._handleCartItemByVariant(variant);
        if (cartItem) {
        const quantityDisplay = cartItem.querySelector('.bundle-cart-item__quantity-container span');
        quantityDisplay.textContent = newQuantity;
        this._changeItemPrice();
        }
    }

    _changeItemPrice() {
        const cartItems = document.querySelectorAll('.bundle-cart-item');
        cartItems.forEach(item => {
        const priceDefault = item.querySelector('.bundle-cart-item__price');
        const priceCompare = item.querySelector('.bundle-cart-item__price-compare');
        const quantityEl = item.querySelector('.bundle-cart-item__quantity-container span');
        const quantityNumber = Number(quantityEl.textContent);

        const itemPriceDefault = (this._totalSum - this._fixedDiscounts[this._totalQuantity]) / this._totalQuantity;
        const itemPriceCompare =  this._compareAtPrice * quantityNumber;
        priceCompare.textContent = `$${itemPriceCompare.toFixed(2)}`;
        });
    }

    _updateDisclamerSum(quantity) {

        if (this._fixedDiscounts[quantity]) {
        const disclamerSum = this._selectableProductVariants[0].productVariants[0].price * quantity - this._fixedDiscounts[quantity];
            const disclamerContainer = document.querySelector('[data-bundle-disclamer-price]');
        if (disclamerContainer) {
            disclamerContainer.textContent = `$${disclamerSum.toFixed(2)}`;
        }
        } else {
        const disclamerSum = this._selectableProductVariants[0].productVariants[0].price * quantity;
            const disclamerContainer = document.querySelector('[data-bundle-disclamer-price]');
        if (disclamerContainer) {
            disclamerContainer.textContent = `$${disclamerSum.toFixed(2)}`;
        }
        }
    }

    _applyDiscount(quantity, sum) {
        this._elements.totalContainer.classList.remove('custom-hidden');
        this._elements.subtotalDiscount.classList.remove('custom-hidden');
        const rawDiscountSum = ((this._compareAtPrice * quantity) + (this._fixedDiscounts[this._totalQuantity]) * 1 - sum);
        const discountSum = Math.round(rawDiscountSum * 100) / 100;
        this._elements.subtotalDiscountSum.textContent = `$${discountSum.toFixed(2)}`;
        const totalSumWithDiscount = this._roundTo2(sum - this._fixedDiscounts[this._totalQuantity]);
        this._elements.subtotalSum.textContent = `$${totalSumWithDiscount.toFixed(2)}`;
        const totalSumAmount = (this._compareAtPrice * quantity).toFixed(2);
        this._elements.totalSumContainer.textContent = `$${totalSumAmount}`;
        this._elements.subtotalQuantity.textContent = quantity;
        this._elements.subtotalDiscount.dataset.discountSum = `$${discountSum.toFixed(2)}`;
        this._updateQuantityText(quantity);
        this._highlightScaleElements(quantity);

        this._updateDisclamerSum(quantity);
    }

    _disableAddButtons() {
        const quantityButtons = document.querySelectorAll('.quantity-selector button');
        const quantityAddButtons = Array.from(quantityButtons).filter(button => button.getAttribute('data-action') === 'plus');
        const defaultAddButtons = document.querySelectorAll('.product-card__button');

        if (this._totalQuantity >= this._sizeRangeMax) {
        quantityAddButtons.forEach(button => button.setAttribute("data-in-cart", "true"));
        defaultAddButtons.forEach(button => button.setAttribute("data-in-cart", "true"));
        } else {
        quantityAddButtons.forEach(button => button.setAttribute("data-in-cart", "false"));
        defaultAddButtons.forEach(button => button.setAttribute("data-in-cart", "false"));
        }
    }  

    _highlightScaleElements(quantity) {
        this._scaleElements.forEach(({ quantity: q, element }) => {
        if (quantity >= q) {
            element.classList.add('active');
        } else {
            element.classList.remove('active');
        }
        });
    }

    _updateSubtotal(quantity, sum) {
        this._elements.subtotalQuantity.textContent = quantity;

        quantity <= 0
        ? this._elements.cartSum.classList.add('custom-hidden')
        : this._elements.cartSum.classList.remove('custom-hidden');
        quantity <= 0
        ? this._elements.subtotalContainer.classList.add('custom-hidden')
        : this._elements.subtotalContainer.classList.remove('custom-hidden');
        quantity <= 0
        ? this._elements.totalContainer.classList.add('custom-hidden')
        : this._elements.totalContainer.classList.remove('custom-hidden'); 
        quantity <= 0
        ? this._elements.recurringPrices.classList.add('custom-hidden')
        : this._elements.recurringPrices.classList.remove('custom-hidden');

        this._elements.subtotalSum.textContent = (quantity <= 0) ? sum.toFixed(2) : `$${sum.toFixed(2)}`;

        this._updateQuantityText(quantity);
        this._elements.subtotalDiscount.classList.add('custom-hidden');
        this._elements.subtotalDiscount.dataset.discountSum = 0;
        this._elements.subtotalDiscountSum.textContent = '';
        this._elements.totalSumContainer.textContent = `$${this._compareAtPrice}`;
        quantity <= 0
        ? this._elements.addAllToCartButton.classList.add('disabled')
        : this._elements.addAllToCartButton.classList.remove('disabled');    

        this._highlightScaleElements(quantity);
    }

    _removeItemFromCart(variant) {
        const cartItem = this._handleCartItemByVariant(variant);
        if (cartItem) {
        cartItem.remove();
        }
        this._disableAddButtons();
        this._changeItemPrice();
    }

    _setupCartCloseHandler() {
        if (!this._elements.closeButton || !this._elements.cartBlock) {
        console.warn('Cart elements not found at setup time.');
        return;
        }
        this._elements.closeButton.addEventListener('click', () => {
        if (this._totalQuantity <= 0) {
            return;
        }
        if (window.innerWidth <= 1023) {
            this._elements.cartBlock.classList.toggle('reduced-height');
            this._elements.closeButton.classList.toggle('rotate');
        }
        });

        window.addEventListener('resize', () => {
        if (window.innerWidth > 1023) {
            this._elements.cartBlock.classList.remove('reduced-height');
        }
        });
    }    

    _updateCloseButtonState() {
        if (this._totalQuantity <= 0) {
        this._elements.closeButton.classList.add('disabled');
        } else {
        this._elements.closeButton.classList.remove('disabled');
        }
    }

    _changeQuantity(evt, product, variant, change, quantitySelector, quantityDisplay, cartItemQuantityDisplay, cartItemPrice, cardBottom, addButton, card) {
        if (evt.currentTarget.dataset.inCart === 'true') {
        const totalSumAlert = this._elements.subtotalDiscount.getAttribute('data-discount-sum');
        this._showTemporaryAlert({ sum: totalSumAlert });
        return;
        } 
        
        const currentQuantity = parseInt(quantityDisplay.textContent, 10);
        const newQuantity = currentQuantity + change;
        this._totalQuantity += change;
        const priceValue = this._getAdjustedPrice(variant);
        const newItemSum = this._roundTo2(priceValue * change);
        this._totalSum = this._roundTo2(this._totalSum + newItemSum);

        if (newQuantity <= 0) {
        this._removeItemFromCart(variant);
        quantityDisplay.textContent = 0;
        cartItemQuantityDisplay.textContent = 0;
        cardBottom.replaceChild(addButton, quantitySelector);
        if (this._fixedDiscounts.hasOwnProperty(this._totalQuantity)) {
            this._applyDiscount(this._totalQuantity, this._totalSum);
        } else {
            this._updateSubtotal(this._totalQuantity, this._totalSum);
        }
        } else {
        const cartItemInCart = this._handleCartItemByVariant(variant);
        if (cartItemInCart) {
            this._updateQuantityInCart(variant, newQuantity);
        } else {
            this._addToCart(evt, card, product, variant);
        }
        quantityDisplay.textContent = newQuantity;
        cartItemQuantityDisplay.textContent = newQuantity;
        const itemSum = this._roundTo2(priceValue * newQuantity);
        cartItemPrice.textContent = `$${itemSum.toFixed(2)}`;
        if (this._fixedDiscounts.hasOwnProperty(this._totalQuantity)) {
            this._applyDiscount(this._totalQuantity, this._totalSum);
        } else {
            this._updateSubtotal(this._totalQuantity, this._totalSum);
        }
        this._disableAddButtons();
        }
        this._updateCloseButtonState();
        this._updateDisclamerSum(this._totalQuantity);
    }

    _removeFromCart(variant, cartItem, quantityDisplay, quantitySelector, cardBottom, addButton) {
        cartItem.remove();
        quantityDisplay.textContent = 0;
        const cardQuantity = this._handleCartItemByVariant(variant, null, true, null);
        if (cardQuantity) {
        cardQuantity.textContent = 0;
        }
        if (quantitySelector) {
        cardBottom.appendChild(addButton);
        cardBottom.removeChild(quantitySelector);
        }
        const itemQuantity = Number(cartItem.querySelector('.bundle-cart-item__quantity-container span').textContent);
        this._totalQuantity -= itemQuantity;
        const priceValue = this._getAdjustedPrice(variant);
        this._totalSum = this._roundTo2(this._totalSum - (priceValue * itemQuantity));
        if (this._fixedDiscounts.hasOwnProperty(this._totalQuantity)) {
        this._applyDiscount(this._totalQuantity, this._totalSum);
        } else {
        this._updateSubtotal(this._totalQuantity, this._totalSum);
        }
        this._disableAddButtons();
        this._changeItemPrice();
        this._updateCloseButtonState();

        this._updateDisclamerSum(this._totalQuantity);
    }

    _addToCart(evt, card, product, variant) {
        if (evt.target.dataset.inCart === 'true') {
        const totalSumAlert = this._elements.subtotalDiscount.getAttribute('data-discount-sum');
        this._showTemporaryAlert({ sum: totalSumAlert });
        return;
        }

        const cartItemsContainer = document.querySelector('.bundle-cart-items');
        const cartItem = document.createElement('div');
        cartItem.classList.add('bundle-cart-item');
        this._handleCartItemByVariant(variant, cartItem);

        const cartItemContent = document.createElement('div');
        cartItemContent.classList.add('bundle-cart-item__content');

        const itemTitle = document.createElement('h4');
        const { titleText, sizeText } = this._parseProductTitle(variant.productVariantTitle);
        itemTitle.innerHTML = `<span>${product.productTitle} - ${titleText}</span><span>${sizeText}</span>`;

        const itemImage = document.createElement('img');
        itemImage.src = variant.imageSrc;
        itemImage.alt = product.productTitle;

        const cartItemPrice = document.createElement('p');
        cartItemPrice.classList.add('bundle-cart-item__price');
        const priceValue = this._getAdjustedPrice(variant);
        const cartItemPriceFormatted = this._roundTo2(priceValue).toFixed(2);

        cartItemPrice.textContent = `$${cartItemPriceFormatted}`;
        cartItemPrice.setAttribute('data-variant-price', cartItemPriceFormatted);

        const cartItemPriceCompare = document.createElement('p');
        cartItemPriceCompare.classList.add('bundle-cart-item__price-compare');
        cartItemPriceCompare.textContent = `$${this._compareAtPrice}`;

        const cartItemPriceDiscounted = document.createElement('span');
        cartItemPriceDiscounted.classList.add('bundle-cart-item__price-discounted');
        cartItemPriceDiscounted.classList.add('highlighted');

        const cartItemPriceContainer = document.createElement('div');
        cartItemPriceContainer.classList.add('bundle-cart-item__price-container');

        const deleteButton = document.createElement('button');
        deleteButton.classList.add('bundle-cart-item__delete');
        deleteButton.setAttribute('aria-label', 'Delete from cart');;
        // Handler for deleting an item from the cart
        deleteButton.addEventListener('click', (evt) => this._removeFromCart(variant, cartItem, quantityDisplay, quantitySelector, cardBottom, addButton));

        const cartItemQuantityContainer = document.createElement('div');
        cartItemQuantityContainer.classList.add('bundle-cart-item__quantity-container');

        const cartItemQuantityDisplay = document.createElement('span');
        cartItemQuantityDisplay.textContent = '1';

        cartItemContent.appendChild(itemTitle);
        cartItemPriceContainer.appendChild(cartItemPriceCompare);
        cartItemPriceContainer.appendChild(cartItemPrice);
        cartItemContent.appendChild(cartItemPriceContainer);
        cartItem.appendChild(itemImage);
        cartItem.appendChild(cartItemContent);
        cartItemQuantityContainer.appendChild(cartItemQuantityDisplay);
        cartItemQuantityContainer.appendChild(deleteButton);
        cartItem.appendChild(cartItemQuantityContainer);
        cartItemsContainer.appendChild(cartItem);

        // Creating items in the product card
        const addButton = card.querySelector('button');
        const quantitySelector = document.createElement('div');
        quantitySelector.classList.add('quantity-selector');

        const decreaseButton = document.createElement('button');
        decreaseButton.dataset.action = 'minus';
        decreaseButton.setAttribute('aria-label', 'Decrease quantity');

        const quantityDisplay = document.createElement('span');
        quantityDisplay.textContent = '1';

        const increaseButton = document.createElement('button');
        increaseButton.dataset.action = 'plus';
        increaseButton.dataset.inCart = 'false';
        increaseButton.setAttribute('aria-label', 'Increase quantity');

        const horizontalLineSingle = document.createElement('span');
        horizontalLineSingle.classList.add('cff-mcc-menu-line');

        const horizontalLine = document.createElement('span');
        horizontalLine.classList.add('cff-mcc-menu-line');

        const verticalLine = document.createElement('span');
        verticalLine.classList.add('cff-mcc-menu-line');
        verticalLine.classList.add('vertical');
        
        const cardBottom = card.querySelector('.product-card__bottom');

        decreaseButton.addEventListener('click', (evt) =>
        this._changeQuantity(evt, product, variant, -1, quantitySelector, quantityDisplay, cartItemQuantityDisplay, cartItemPrice, cardBottom, addButton, card)
        );
        increaseButton.addEventListener('click', (evt) =>
        this._changeQuantity(evt, product, variant, 1, quantitySelector, quantityDisplay, cartItemQuantityDisplay, cartItemPrice, cardBottom, addButton, card)
        );

        decreaseButton.appendChild(horizontalLineSingle);
        increaseButton.appendChild(horizontalLine);
        increaseButton.appendChild(verticalLine);
        quantitySelector.appendChild(decreaseButton);
        quantitySelector.appendChild(quantityDisplay);
        quantitySelector.appendChild(increaseButton);

        if (addButton.textContent === 'Add') {
        cardBottom.replaceChild(quantitySelector, addButton);
        }

        const newVariantPrice = this._roundTo2(priceValue);
        this._totalQuantity += 1;
        this._totalSum = this._roundTo2(this._totalSum + newVariantPrice);

        if (this._fixedDiscounts.hasOwnProperty(this._totalQuantity)) {
        this._applyDiscount(this._totalQuantity, this._totalSum);
        } else {
        this._updateSubtotal(this._totalQuantity, this._totalSum);
        }
        this._disableAddButtons();

        // Price update for all cart items
        const cartItemsInCart = document.querySelectorAll('.bundle-cart-item');
        cartItemsInCart.forEach(item => {
        const priceDefault = item.querySelector('.bundle-cart-item__price');
        const priceCompare = item.querySelector('.bundle-cart-item__price-compare');
        const quantityEl = item.querySelector('.bundle-cart-item__quantity-container span');
        const quantityNumber = Number(quantityEl.textContent);
        if (this._totalQuantity >= this._sizeRangeMin) {
            const itemPriceDefault = (this._totalSum - this._fixedDiscounts[this._totalQuantity]) / this._totalQuantity;
            const itemComparedPrice = this._compareAtPrice * quantityNumber;
            priceCompare.textContant = `$${itemComparedPrice.toFixed(2)}`;
        }
        });
        this._updateCloseButtonState();
        this._updateDisclamerSum(this._totalQuantity);
    }

    _getBundleDiscountedPrice = (originalPrice) => {
        let discountPercent = 0;
        if (this._fixedDiscounts) {
        const discountLevels = Object.keys(this._fixedDiscounts).map(Number).sort((a, b) => a - b);
        for (const level of discountLevels) {
            if (this._totalQuantity >= level) {
            discountPercent = this._fixedDiscounts[level];
            }
        }
        }
        return originalPrice * (1 - discountPercent / 100);
    };

    _addProductsFromBoxToCart() {
        this._elements.addAllToCartButton.addEventListener('click', () => {
        const addButtonText = this._elements.addAllToCartButton.querySelector('span');
        const spinner = this._elements.addAllToCartButton.querySelector('.spinner');
        spinner.classList.remove('custom-hidden');
        this._elements.addAllToCartButton.disabled = true;
        addButtonText.innerHTML = '';

        const variantsInCart = document.querySelectorAll('.bundle-cart-item');

        const _getTotalQuantityInCart = () => {
            let total = 0;
            variantsInCart.forEach(item => {
            const quantityEl = item.querySelector('.bundle-cart-item__quantity-container span');
            if (quantityEl) {
                const quantity = parseInt(quantityEl.textContent, 10);
                if (!isNaN(quantity)) total += quantity;
            }
            });
            return total;
        };

        const totalCartQuantity = _getTotalQuantityInCart();

        if (totalCartQuantity < this._sizeRangeMin) {
            this._showTemporaryAlert();
            this._elements.addAllToCartButton.disabled = false;
            spinner.classList.add('custom-hidden');
            addButtonText.innerHTML = 'Checkout';
        } else {
            const items = [];
            variantsInCart.forEach(item => {
                const variantId = item.getAttribute('data-variant-id');
                const quantity = item.querySelector('.bundle-cart-item__quantity-container span').textContent;
                if (variantId && quantity) {
                    items.push({
                    variantId: Number(variantId),
                    quantity: Number(quantity)
                    });
                }
            });

            const _addToCartCheckout = async (item, boxIndex) => {
                try {
                    if (!'/cart/add') {
                        throw new Error('Cart add URL is not defined.');
                    }
                    const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                        id: Number(item.variantId),
                        quantity: Number(item.quantity),
                        selling_plan: this._sellingPlanId,
                        properties: {
                        _dynamicBoxIndex: boxIndex,
                        _dynamicBoxId: this._boxId
                        }
                    })
                    });
                    if (response) {
                        if (response.ok) {
                            await response.json();
                        } else {
                            const errorData = await response.text();
                            console.error('Error adding product. Status:', response.statusText, 'Details:', errorData);
                        }
                    } else {
                        console.error('No response from server.');
                    }
                } catch (error) {
                    console.error('Error executing request:', error);
                }
            };
            
            const _addAllToCart = async (items) => {
            let boxIndex = 0;
            const cartItems = await this._getCartItems();
            const existingBoxIndexes = cartItems
            .map(cartItem => cartItem.properties._dynamicBoxIndex)
            .filter(index => typeof index === 'number' && !isNaN(index));

            if (existingBoxIndexes.length > 0) {
            boxIndex = Math.max(...existingBoxIndexes) + 1;
            }

            const itemsToAdd = items.map(item => ({
            id: Number(item.variantId),
            quantity: Number(item.quantity),
            selling_plan: this._sellingPlanId,
            properties: {
                _dynamicBoxIndex: boxIndex,
                _dynamicBoxId: this._boxId
            }
            }));

            // Prepare cart attributes
            const cartAttributes = {};
            const painpoint = window.getPainpoint && window.getPainpoint();
            if (painpoint) {
            cartAttributes.painpoint = painpoint;
            }

            try {
                await fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                    items: itemsToAdd,
                    attributes: cartAttributes
                    })
                });

                if (!response.ok) {
                    const errorData = await response.text();
                    console.error('Error adding products. Status:', response.statusText, 'Details:', errorData);
                }
            } catch (error) {
                console.error('Error executing request:', error);
            }

            const productCards = document.querySelectorAll('.product-card');
            productCards.forEach(card => {
            const quantitySelector = card.querySelector('.quantity-selector');
            if (quantitySelector) {
                const quantityDisplay = quantitySelector.querySelector('span');
                const cardVariantId = card.getAttribute('data-variant-id');
                const cardBottom = card.querySelector('.product-card__bottom');
                if (cardBottom) {
                const addButton = document.createElement('button');
                addButton.classList.add('product-card__button');
                addButton.setAttribute('aria-label', 'Add to Cart');
                addButton.textContent = 'Add';
                if (this._selectableProductVariants && Array.isArray(this._selectableProductVariants)) {
                    this._selectableProductVariants.forEach(variant => {
                    variant.productVariants.forEach(v => {
                        const variantId = v.platformId;
                        if (variantId.includes(cardVariantId)) {
                        addButton.addEventListener('click', (evt) => this._addToCart(evt, card, variant, v));
                        variantsInCart.forEach(item => {
                            const itemVariantId = item.getAttribute('data-variant-id');
                            if (variantId.includes(itemVariantId)) {
                            this._removeFromCart(v, item, quantityDisplay, quantitySelector, cardBottom, addButton);
                            }
                        });
                        }
                    });
                    });
                }
                }
            }
            });

            const discountElem = this._elements.subtotalDiscount;
            if (discountElem) {
            discountElem.classList.add('custom-hidden');
            discountElem.dataset.discountSum = 0;
            }
            this._elements.subtotalDiscountSum.textContent = 0;
            this._elements.subtotalSum.textContent = 0;
            this._elements.subtotalSum.classList.remove('highlighted');
            this._elements.subtotalQuantity.textContent = 0;

            this._elements.addAllToCartButton.disabled = false;
            spinner.classList.add('custom-hidden');
            addButtonText.innerHTML = 'Checkout';
            window.location.href = '/checkout'; // Redirect if necessary 
        };

            const _getCartItems = async () => {
            const response = await fetch('/cart.js');
            if (response.ok) {
                const data = await response.json();
                return data.items;
            } else {
                console.error('Error when retrieving items from cart');
                return [];
            }
            };

            this._getCartItems = _getCartItems;
            _addAllToCart(items);
        }
        });
    }

    _getAdjustedPrice(variant) {
        if (!this._sellingPlanGroup) return null;
        let subscriptionDiscount = 0;

        const planEntry = Object.entries(this._sellingPlanGroup).find(([key, plan]) => plan.position === 0);

        const plan = planEntry[1];
        const variantData = plan.variantMapping?.[variant.platformId];
        const adjustedPrice = variantData.adjustedPrice;
        
        return adjustedPrice;
    }

    _renderProductCards() {
        const container = document.createElement('div');
        container.classList.add('product-container');

        if (this._selectableProductVariants && Array.isArray(this._selectableProductVariants)) {
        this._selectableProductVariants.forEach(variant => {
            variant.productVariants.forEach(productVariant => {
            const card = document.createElement('div');
            card.classList.add('product-card');
            
            this._handleCartItemByVariant(productVariant, card, false, true);

            const image = document.createElement('img');
            image.src = productVariant.imageSrc;
            image.alt = variant.productTitle;

            const cardContent = document.createElement('div');
            cardContent.classList.add('product-card__content');

            const title = document.createElement('h3');
            title.classList.add('heading');
            const { titleText, sizeText } = this._parseProductTitle(productVariant.productVariantTitle);
            title.innerHTML = `<span>${variant.productTitle} - ${titleText}</span><span>${sizeText}</span>`;

            const cardBottom = document.createElement('div');
            cardBottom.classList.add('product-card__bottom');

            const priceContainer = document.createElement('div');
            priceContainer.classList.add('product-card__price-container');

            const priceCompare = document.createElement('p');
            priceCompare.classList.add('product-card__price-compare');
            priceCompare.textContent = `$${productVariant.price}`;

            const price = document.createElement('p');
            price.classList.add('product-card__price');
            const priceValue = this._getAdjustedPrice(productVariant);
            price.textContent = `$${this._roundTo2(priceValue).toFixed(2)}`;

            const addButton = document.createElement('button');
            addButton.classList.add('product-card__button');
            addButton.setAttribute('aria-label', 'Add to Cart');
            addButton.textContent = 'Add';
            addButton.dataset.inCart = 'false';
            addButton.addEventListener('click', (evt) => this._addToCart(evt, card, variant, productVariant));

            card.appendChild(image);
            card.appendChild(cardContent);
            cardContent.appendChild(title);
            cardContent.appendChild(cardBottom);
            priceContainer.appendChild(priceCompare);
            priceContainer.appendChild(price);
            cardBottom.appendChild(priceContainer);
            cardBottom.appendChild(addButton);
            container.appendChild(card);
            });
        });
        this._addProductsFromBoxToCart();
        } else {
        console.error('Unexpected data structure:', this._selectableProductVariants);
        }
        this._elements.boxContainer.appendChild(container);
    }
}

// Initialization of BundleBox with passing API URL and product ID
if (window.bundleBoxData && window.bundleBoxData.apiUrl && window.bundleBoxData.productPlatformId) {
    new BundleBox(window.bundleBoxData.apiUrl, window.bundleBoxData.productPlatformId);
} else {
    console.error('Bundle box data is not defined');
}